// extracted by mini-css-extract-plugin
export const title = "listings-acquisitions-module--title--27RAs";
export const listings = "listings-acquisitions-module--listings--dABgB";
export const cardTitle = "listings-acquisitions-module--cardTitle--2Ix-Y";
export const cardContent = "listings-acquisitions-module--cardContent---WcSI";
export const cardImage = "listings-acquisitions-module--cardImage--pTRrQ";